import React, { type PropsWithChildren } from 'react';
import ClientPageBanner from 'ts/common/components/ClientPageBanner';
import ClientPageLayout from 'ts/common/components/ClientPageLayout';
import { useTranslate } from 'ts/common/hooks';

interface Props {
    contract: SpApi.Client.IContract;
    contractUserEmail: string | null;
}

const PageContainer: React.FC<PropsWithChildren<Props>> = ({
    children,
    contract,
    contractUserEmail
}) => {
    const t = useTranslate('contract.pageContainer');

    const contractUserFirstName = contract.contacts?.find(
        (contact) => contact.email === contractUserEmail
    )?.firstName;

    return (
        <ClientPageLayout
            banner={
                <ClientPageBanner
                    subtitle={
                        contract.contacts?.[0]?.firstName
                            ? t('pleaseReviewAndSignContract')
                            : undefined
                    }
                >
                    {contractUserFirstName ? `HI, ${contractUserFirstName}` : contract.name}
                </ClientPageBanner>
            }
            headingText={contract.brandName}
        >
            {children}
        </ClientPageLayout>
    );
};

export default PageContainer;
